<div class="range-slider">
  <input
    type="range"
    [min]="min"
    [max]="max"
    [step]="step"
    [value]="value"
    [disabled]="disabled"
    (input)="handleInput($event)"
     />
  <output></output>
  <div class="range-slider__progress"></div>
</div>
